import { render } from "./TradesNew.vue?vue&type=template&id=672cb16c&scoped=true"
import script from "./TradesNew.vue?vue&type=script&lang=js"
export * from "./TradesNew.vue?vue&type=script&lang=js"

import "./TradesNew.vue?vue&type=style&index=0&id=672cb16c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672cb16c"]])

export default __exports__